export const post = {
  id: "eight-months-of-uncertainty",
  title: "Eight Months of Uncertainty: Finding Strength During Unemployment",
  excerpt: "Reflections on my journey through 8 months of job hunting, self-improvement, and confronting feelings of failure.",
  image: "https://images.unsplash.com/photo-1516383740770-fbcc5ccbece0?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1074&q=80",
  category: "Self Improvement",
  date: "February 25, 2025",
  readTime: 7,
  slug: "eight-months-of-uncertainty",
  content: `
I watched *Josee, the Tiger and the Fish* today. There's this scene where the main character gets hurt and starts to question everything—his dreams, his future. It hit me harder than I expected. Because honestly, that’s where I am right now too.

## This Stagnant Phase

It’s been eight months since I finished uni. Five since I officially graduated. And yet, here I am—still jobless.

Applications sent. Interviews done. Rejections piling up. And silence, a lot of silence. Meanwhile, people around me are moving on—new jobs, new cities, new lives. And I’m still here.

I’ve fought to get where I am. I didn’t come from a top school. I worked my way up—became the best student in a school no one expected anything from. Then I did that again in college, and eventually made it into one of the best unis in the world. I thought, “Surely this momentum will carry me through.”

But it didn’t. I hit a wall. And it’s made me question everything.

## I Grew... But Didn't Move

What makes this harder is that I haven’t just been sitting around. Over the past eight months, I’ve:

- Built multiple coding projects
- Trained for and completed a marathon
- Gotten faster, stronger, more disciplined
- Picked up new technical skills

But none of that has gotten me what I wanted most—my first real opportunity. Career-wise, I’m still stuck at the starting line.

## People Mean Well, But...

I’ve heard more advice than I can count. Most of it from people who’ve never walked the same path. I know they mean well, but it often feels out of touch.

Even my dad, who once went through 1.5 years of unemployment, keeps trying to reassure me with his own experience. But it doesn’t help. If anything, it makes me feel worse. Because deep down, I really thought things would be different. That I would be able to beat the odds again.

So when I didn’t—it broke me in a way I didn’t see coming.

## Something's Gotta Give

I know the definition of insanity. Repeating the same things and expecting different results. So something has to change. I need to take things one step at a time and refocus on what I *can* control.

But tonight, I’m just tired. Tonight, I feel like a failure. And that word—failure—cuts deep when you’ve spent your whole life fighting not to be one.

## A Promise to Myself

At the start of the year, I made myself one promise: **not to give up on myself**.

So even now, even with all this frustration and pain, I’m still here. Still writing. Still reminding myself why I started.

On the days when my legs feel like lead, and I can barely take the pain, I always repeat to myself:

*Alwi. Don't give up on me now. You’ve come too far to quit. If you can't give me one more kilometre, give me a few hundred metres. If you can't do that, give me another step. And another. And another...*

I repeat this over and over again until I finish the distance I set out to run.

And just like with running, I’ll get up tomorrow and try again. Smarter. Different. With a little more patience—and a little more grit.

If you’re reading this and going through your own stretch of uncertainty, know this: you’re not alone. We’re all stumbling forward, one *no* at a time, until that one *yes* finally breaks through.

  `
};
